import { cloneDeep, has } from 'lodash'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import { SET_USER, RESET_USER } from 'vx/mutations'

export default {
  computed: {
    ...mapState('user', ['authorized']),
    ...mapGetters('user', ['user']),

    /**
     * Determine if we are editing a user that is not ourselves.
     *
     * @return boolean
     */
    editingDifferentUser () {
      return has(this.$route.params, 'id')
    }
  },

  methods: {
    ...mapActions('user', ['getUser']),
    ...mapMutations('user', [SET_USER, RESET_USER]),

    /**
     * Attempt to load an existing user if we are editing someone that is not ourselves.
     *
     * @return void
     */
    attemptToLoadExistingUser () {
      this[RESET_USER]()

      // If we are editing a different user, that is, we are either an admin editing
      // a user or we are a parent account editing a child account, we'll fetch the
      // user from the API.
      if (this.editingDifferentUser) {
        return this.getUser(this.$route.params.id)

      // Otherwise we'll simply set the user state to the authorized user state.
      // It's important that we use the state and not the getter because we map
      // the user being edited via a getter that wraps it in our User utility.
      // We need to cloneDeep this object so changes are not persisted to
      // the authorized user state.
      } else {
        return this.useAuthorizedUser()
      }
    },

    /**
     * Use the authorized user.
     *
     * @return Promise
     */
    useAuthorizedUser () {
      this[SET_USER](cloneDeep(this.authorized))

      return Promise.resolve()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/user/existing-user.js